import Vue from "vue";
import Vuex from "vuex";
import Api from "./api";
import Router from "./router";
import config from "./config";
import { applyProgramFont } from "./helpers/font";
Vue.use(Vuex);

const PREVIEW_CLIENT = {
    id: "preview",
    first_name: "Gabriel",
    last_name: "Chiminelli",
    email: "gabriel@kevi.io",
    birthdate: "1996-01-01",
};

const store = new Vuex.Store({
    state: {
        globalStatus: "loading",
        token: null,
        modal: null,
        rewardId: null,
        redeemed: null,
        client: {
            id: null,
            first_name: null,
            last_name: null,
            email: null,
            birthdate: null,
        },
        place: {
            id: null,
            name: null,
            logo: null,
            color: null,
            mainColor: null,
            benefit_program: null,
        },
    },
    getters: {
        clientEmailRequired(state) {
            return state.place?.benefit_program?.login?.form?.emailRequired !== false;
        },
        clientHasProfileCompleted(state, getters) {
            let c = state.client;
            return (
                !!c.first_name &&
                !!c.last_name &&
                !!c.birthdate &&
                (!!c.email || !getters.clientEmailRequired)
            );
        },
        pointsProgramActive(state) {
            return state.place?.benefit_program?.pointsProgramActive === true;
        },
        hasActiveProgram(state, getters) {
            return getters.pointsProgramActive;
        },
        globalStatus: (state) => (status) => {
            return state.globalStatus === status;
        },
    },
    actions: {
        init({ commit, dispatch }) {
            if (config.isPreview) {
                commit("setToken", "preview");
                commit("setClient", { ...PREVIEW_CLIENT });

                return;
            }

            let token = window.localStorage.getItem("token");
            let client = window.localStorage.getItem("client");

            if (token && token !== "null" && token !== "undefined") {
                commit("setToken", token);
                commit("setClient", client ? JSON.parse(client) : null);
            } else {
                commit("setToken", null);
                commit("setClient", null);
            }

            dispatch("loadPlace", window.PLACE_SLUG);
        },
        updateClientInfo({ commit, state }) {
            if (config.isPreview) {
                return Promise.resolve(state.client);
            }

            return Api.get("client/profile").then((response) => {
                commit("setClient", response.body.client);

                return response.body.client;
            });
        },
        logout({ commit }) {
            commit("setToken", null);
            commit("setClient", null);
            Router.push("/").catch(() => {});
        },
        loadPlace({ commit }, slug) {
            Api.get("place/" + slug + "/public-info")
                .then((infoResponse) => {
                    commit("setGlobalStatus", "loaded");
                    let place = infoResponse.body;
                    commit("setPlace", place);
                })
                .catch((response) => {
                    const notFound = response && response.status === 404;
                    commit("setGlobalStatus", notFound ? "not-found" : "error");
                });
        },
    },
    mutations: {
        setGlobalStatus(state, status) {
            state.globalStatus = status;
        },
        setClient(state, client) {
            if (!config.isPreview) {
                if (client && client.id) {
                    window.localStorage.setItem("client", JSON.stringify(client));
                } else {
                    window.localStorage.removeItem("client");
                }
            }

            state.client = client || {};
        },
        setToken(state, token) {
            if (!config.isPreview) {
                if (token) {
                    window.localStorage.setItem("token", token);
                } else {
                    window.localStorage.removeItem("token");
                }
            }

            state.token = token;
        },
        setPlace(state, place) {
            state.place = place;
            applyProgramFont((place && place.benefit_program && place.benefit_program.font) || "");
        },
        openModal(state, modal) {
            state.modal = modal;
        },
        closeModal(state) {
            state.modal = null;
        },
        openReward(state, id) {
            state.rewardId = String(id);
        },
        closeReward(state) {
            state.rewardId = null;
        },
        openRedeemSuccess(state, redeemed) {
            state.redeemed = redeemed;
        },
        closeRedeemSuccess(state) {
            state.redeemed = null;
        },
    },
});

export default store;
